import { ref } from 'vue'

import { useConfirm } from 'src/composables/app/useConfirm'

import { idbService } from 'src/services/app/idb.service'
import { log } from 'src/services/app/log.service'
import { notifyService } from 'src/services/app/notify.service'
import { STORAGE_KEYS } from 'src/services/consts/api.const'
import { NOTIFICATION_MESSAGES } from 'src/services/consts/notification.const'

export function useClearCache() {
  const { confirmClearCache } = useConfirm()
  const isClearing = ref(false)

  async function clearAppDataCache() {
    const companiesRemoved = await idbService.removeData(STORAGE_KEYS.COMPANIES)
    const requestsRemoved = await idbService.removeData(STORAGE_KEYS.CREATION_REQUESTS)

    if (!companiesRemoved || !requestsRemoved) {
      throw new Error('Failed to remove IndexedDB cache')
    }

    window.location.reload()
  }

  function onClearCache() {
    confirmClearCache(async () => {
      isClearing.value = true
      try {
        await clearAppDataCache()
      } catch (err) {
        log.error('Clear cache failed:', err)
        notifyService.error(NOTIFICATION_MESSAGES.error.clearCache)
        throw err
      } finally {
        isClearing.value = false
      }
    })
  }

  return {
    onClearCache,
    isClearing,
  }
}
